import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "designversion",
  listKey: "versions",
  itemKey: "version",
  getAll: types.GET_ALL_DESIGN_VERSIONS,
  getAllResponse: types.GET_ALL_DESIGN_VERSIONS_RESPONSE,
  getByIdResponse: types.GET_DESIGN_VERSION_BY_ID_RESPONSE,
});
